"use client";

interface BannerSectionProps {
  title: string;
}

import { useTranslations } from "next-intl";
import banner from "@/assets/images/banner/banner.png";

export const BannerSection = ({ title }: BannerSectionProps) => {
  const t = useTranslations("banner");

  return (
    <div
      className="flex h-[50dvh] w-full items-center justify-center overflow-x-hidden bg-cover bg-center bg-no-repeat px-4 py-8 ph:px-24 ph:py-16 md:px-48 lg:px-72 xl:px-96"
      style={{
        backgroundImage: `url(${banner.src}), radial-gradient(circle, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)`,
      }}
    >
      <h1 className="text-center font-trainOne text-3xl font-extralight uppercase text-white ph:text-4xl lg:text-6xl">
        {title}
      </h1>
    </div>
  );
};
